// modules
import AuthStore from 'modules/Auth';
import AppStore from 'modules/App';
import { WsLiveV2Feeder, WsPortfolioV2Feeder } from 'modules/WebSocket';
import UserStore from 'modules/User';
import LocaleStore from 'modules/Localization';
import LoadingStore from 'modules/Loading';
import RoutingStore from 'modules/Routing';
import ErrorStore from 'modules/Error';
import LiveDataStore from 'modules/LiveData';
import SearchStore from 'modules/Search';
import Platform from 'modules/Platform';
import NotificationStore from 'modules/Notifications';
import TradingChartStore from 'modules/TradingChart';
import { fundsStore as FundsStore } from 'modules/Funds';
import HoldingsStore from 'modules/TradesPW3/Holdings/HoldingsService';
import OrdersStore from 'modules/TradesPW3/Orders';
import PositionsPW3Service from 'modules/TradesPW3/Positions/positions';
import OptionChainStore from 'modules/OptionChain';
import ChartSyncStore from 'modules/ChartSync';
import NotificationCenterStore from 'modules/NotificationCenter';
import PriceAlertsStore from 'modules/PriceAlerts';
import UnderlyingChartsStore from 'modules/UnderlyingCharts';

const STORES = {
  AppStore,
  AuthStore,
  SearchStore,
  UserStore,
  LocaleStore,
  LoadingStore,
  RoutingStore,
  ErrorStore,
  LiveDataStore,
  Platform,
  NotificationStore,
  TradingChartStore,
  FundsStore,
  HoldingsStore,
  OrdersStore,
  PositionsPW3Service,
  WsPortfolioV2Feeder,
  WsLiveV2Feeder,
  OptionChainStore,
  ChartSyncStore,
  NotificationCenterStore,
  PriceAlertsStore,
  UnderlyingChartsStore,
};

export default STORES;
